





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IDocType } from "@/@types/admin/guest/user";
import { calculateAge as getAge } from "@/services/dateTime/ages";

import Document0 from "@/components/forms/users/guest/document_types/document0.vue";
import Document2 from "@/components/forms/users/guest/document_types/document2.vue";
import Document4 from "@/components/forms/users/guest/document_types/document4.vue";
import Document8 from "@/components/forms/users/guest/document_types/document8.vue";
import Document from "@/components/forms/users/guest/document_types/document.vue";

import identity_cards from "@/config/identity/identity_cards";

@Component({
  components: {
    Document0,
    Document2,
    Document4,
    Document8,
    Document,
  },
})
export default class DocumentsForm extends Vue {
  @Prop({ type: String, default: "" }) docType!: string;
  @Prop({ type: String, default: "" }) docNumber!: string;
  @Prop({ type: Date, default: null }) birthday!: Date | null;
  @Prop({ type: Boolean, default: true }) required!: boolean;

  docTypes: Array<IDocType> = identity_cards;

  get getDocType(): string {
    if (this.docType == "0") return "document0";
    if (this.docType == "2") return "document2";
    if (this.docType == "4" || this.docType == "11") return "document4";
    if (this.docType == "8") return "document8";
    return "document";
  }

  get getDocument(): IDocType | null {
    const type = this.docTypes.find((doc) => doc._id == this.docType);
    return type ? type : null;
  }

  get age(): number {
    if (this.birthday) return getAge(this.birthday);
    return -1;
  }

  @Watch("birthday")
  autoUpdateDocType(): void {
    if (this.age == -1) {
      this.$emit("type", "0");
      return;
    }
    if (this.age < 14 && this.docType == "0") {
      this.$emit("type", "4");
      return;
    }
    if (this.age >= 14 && this.docType == "4") this.$emit("type", "0");
  }

  mounted(): void {
    this.$nextTick(() => this.autoUpdateDocType());
  }
}
